///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2021, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { BaseLoader } from "./BaseLoader";

export class VsfXLoader extends BaseLoader {
  override async load(): Promise<void> {
    if (!this.viewer.visualizeJs) return;

    const visLib = this.viewer.visLib();
    const visViewer = visLib.getViewer();
    const abortController = new AbortController();

    this.viewer._abortController = abortController;

    const chunkLoadHandler = (progress: number) => {
      this.viewer.emitEvent({ type: "geometryprogress", data: progress, model: this.model });
    };

    console.time("File load time");
    try {
      this.viewer.emitEvent({ type: "geometrystart", model: this.model });

      const arrayBuffer = await this.model.downloadResource(
        this.model.database,
        chunkLoadHandler,
        abortController.signal
      );

      if (abortController.signal.aborted) {
        await Promise.reject(new Error(`Open model aborted ${this.model.name}`));
      }

      const data = new Uint8Array(arrayBuffer);

      if (this.viewer.visualizeJs) {
        visViewer.parseVsfx(data);

        this.viewer.syncOpenCloudVisualStyle(false);
        this.viewer.syncOptions();
        this.viewer.resize();
      }

      console.timeEnd("File load time");

      this.viewer.emitEvent({ type: "databasechunk", data, model: this.model });
      this.viewer.emitEvent({ type: "geometryend", model: this.model });
    } catch (error: any) {
      this.viewer.emitEvent({ type: "geometryerror", data: error, model: this.model });
      throw error;
    }
  }
}
